import React from 'react';
import type { Severity } from '../../../utils/scanReport';

/** Hedged signal language — never present a pattern as a verified fact. */
export const SIGNAL_LABEL: Record<Severity, string> = {
  HIGH: 'High signal',
  MEDIUM: 'Moderate signal',
  LOW: 'Low signal'
};
export const SIGNAL_DISCLAIMER = 'Model estimates based on communication patterns in this conversation.';
const FILLED: Record<Severity, number> = {
  HIGH: 3,
  MEDIUM: 2,
  LOW: 1
};
export function severityFromScore(score: number): Severity {
  if (score >= 70) return 'HIGH';
  if (score >= 40) return 'MEDIUM';
  return 'LOW';
}
interface SeverityMeterProps {
  severity: Severity;
  showLabel?: boolean;
}

/** A small three-segment crimson indicator — hierarchy without red-filled cards. */
export function SeverityMeter({
  severity,
  showLabel = true
}: SeverityMeterProps) {
  const filled = FILLED[severity];
  return <span className="inline-flex items-center gap-2" data-id="element-396" data-mp="1p4rykk2ahb73">
      <span className="inline-flex items-center gap-[3px]" role="img" aria-label={SIGNAL_LABEL[severity]} data-id="element-397" data-mp="1p6ctiasimw5h">
        {[0, 1, 2].map(i => <span key={i} className={`h-1 w-3.5 rounded-full ${i < filled ? 'bg-forensic-crimson' : 'bg-white/10'}`} data-id="element-398" data-mp="jxko382eps01" />)}
      </span>
      {showLabel && <span className="whitespace-nowrap text-xs text-forensic-muted" data-id="element-399" data-mp="spuyoqh7rzht">
          {SIGNAL_LABEL[severity]}
        </span>}
    </span>;
}